export function initGalleryCarousel() {
    const limitTrack = 6;
    const carousels = document.querySelectorAll('.dcGalleryCarousel');
    if (!carousels.length) return;

    carousels.forEach(carousel => {
        const items = Array.from(carousel.querySelectorAll('.dcGalleryCarouselItem'));
        if (!items.length) return;
        carousel.innerHTML = '';

        const isSingle = carousel.classList.contains('dcGalleryCarousel--single');
        const isScroll = carousel.classList.contains('dcGalleryCarousel--scroll');
        const hasTwoRows = !isSingle && items.length > limitTrack;
        const mid = hasTwoRows ? Math.ceil(items.length / 2) : items.length;
        const topItems = items.slice(0, mid);
        const bottomItems = hasTwoRows ? items.slice(mid) : [];

        const buildRow = (rowItems) => {
            const row = document.createElement('div');
            row.className = 'dcGalleryCarousel__row';

            const track = document.createElement('div');
            track.className = 'dcGalleryCarousel__track';

            rowItems.forEach(item => track.appendChild(item));
            row.appendChild(track);
            carousel.appendChild(row);

            return { track, originalItems: Array.from(track.children) };
        };

        const fillTrack = (data) => {
            const { track, originalItems } = data;
            const originalWidth = track.scrollWidth;
            const targetWidth = (carousel.offsetWidth || window.innerWidth) * 3;

            let iterations = 0;
            while (track.scrollWidth < targetWidth && iterations < 20) {
                originalItems.forEach(item => {
                    const clone = item.cloneNode(true);
                    clone.setAttribute('data-clone', 'true');
                    // Klone sind reine Marquee-Fuellung und zeigen dasselbe Bild
                    // wie das Original. Fokussierbare Duplikate sind auch mit
                    // Namen ein Bedienproblem und waren im dcLens-Lauf vom
                    // 27.08.2026 der groesste Posten unter a11y/button-name
                    // (228 Vorkommen). Raus aus Tab-Reihenfolge und AT-Baum.
                    clone.setAttribute('aria-hidden', 'true');
                    clone.setAttribute('tabindex', '-1');
                    clone.addEventListener('click', (e) => {
                        e.preventDefault();
                        const index = clone.getAttribute('data-index');
                        const original = track.querySelector(`.js-openGallery[data-index="${index}"]:not([data-clone])`);
                        if (original) original.click();
                    });
                    track.appendChild(clone);
                });
                iterations++;
            }

            return originalWidth;
        };

        const topData = buildRow(topItems);
        const bottomData = hasTwoRows ? buildRow(bottomItems) : null;

        const topOriginalWidth = (hasTwoRows || isSingle || isScroll) ? fillTrack(topData) : topData.track.scrollWidth;
        const bottomOriginalWidth = hasTwoRows ? fillTrack(bottomData) : 0;

        if (isScroll) {
            const scrollSpeed = 0.2;
            const elTopAbsolute = carousel.getBoundingClientRect().top + window.scrollY;
            const initialRel = Math.max(0, window.innerHeight - elTopAbsolute);

            const onScroll = () => {
                const rel = Math.max(0, window.scrollY + window.innerHeight - elTopAbsolute) - initialRel;

                let topOffset = -(rel * scrollSpeed) % topOriginalWidth;
                if (topOffset > 0) topOffset -= topOriginalWidth;
                topData.track.style.transform = `translateX(${topOffset}px)`;

                if (bottomData) {
                    const bottomOffset = (rel * scrollSpeed) % bottomOriginalWidth;
                    bottomData.track.style.transform = `translateX(${-(bottomOriginalWidth - bottomOffset)}px)`;
                }
            };

            window.addEventListener('scroll', onScroll, { passive: true });
        } else {
            let speed = 0.5;
            let topPos = 0;
            let bottomPos = -bottomOriginalWidth;

            if (window.innerWidth < 768) speed = 0.2;

            const animate = () => {
                topPos -= speed;
                if (topPos <= -topOriginalWidth) topPos = 0;
                topData.track.style.transform = `translateX(${topPos}px)`;

                if (bottomData) {
                    bottomPos += speed;
                    if (bottomPos >= 0) bottomPos = -bottomOriginalWidth;
                    bottomData.track.style.transform = `translateX(${bottomPos}px)`;
                }

                requestAnimationFrame(animate);
            };

            requestAnimationFrame(animate);
        }

        carousel.classList.add('is-initialized');
    });
}